import cn from 'clsx';
import { ButtonHTMLAttributes, FC, forwardRef, useContext, useMemo } from 'react';

import AccordionIcon from '../AccordionIcon';
import AccordionContext from '../context';

import s from './NumberAccordionButton.module.scss';

export interface NumberAccordionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  description?: string;
  number: string;
}

const NumberAccordionButton: FC<NumberAccordionButtonProps> = forwardRef<HTMLButtonElement, NumberAccordionButtonProps>(
  ({ title, description, number, ...rest }, ref) => {
    const NumberAccordionButtonContext = useContext(AccordionContext);

    const style = useMemo(() => {
      return NumberAccordionButtonContext?.isExpanded ? s.expanded : s.collapsed;
    }, [NumberAccordionButtonContext?.isExpanded]);

    return (
      <button className={s['click-area']} type="button" ref={ref} {...rest} onClick={NumberAccordionButtonContext?.onClick}>
        <div className={cn(s.circle, style)}>
          <span className={cn(s.number, style)}>{number}</span>
        </div>
        <div className={s.wrapper}>
          <h1 className={s.title}>{title}</h1>
          {description && <p className={s.description}>{description}</p>}
        </div>
        <AccordionIcon />
      </button>
    );
  }
);

export default NumberAccordionButton;
